import React, {Children, MutableRefObject, PropsWithChildren} from 'react';
import {Form as FormikForm, Formik, FormikConfig} from "formik";
import FormControls from "../../FormControls";
import {FormSectionProps} from "./FormSection";
import {SubmitAction} from "../../../hooks/useSubmitActionRef";
import {ErrorNotification} from "../ErrorNotification";

function Form({children, submitActionRef,...props}: PropsWithChildren<FormikConfig<any> & {submitActionRef?: MutableRefObject<SubmitAction>}>) {

  function renderChildren() {
    let firstSection = null;

    return Children.map(children, child => {
      if (React.isValidElement<FormSectionProps>(child)) {
        // If this is the first valid form section, mark it as the first child
        firstSection ??= child;

        // If this is the first form section, mark it as "isTop"
        return React.cloneElement(child, {isTop: firstSection === child})
      }

      return child
    });
  }

  return (
    <Formik {...props}>
      {(formik) => {
        return (
          <FormikForm>
            <ErrorNotification formik={formik} />
  
            <div className="shadow sm:rounded-md">
              <div className="px-4 py-5 bg-white sm:p-6 sm:rounded-md">
                <div className="space-y-8 divide-y divide-gray-200">
                  {renderChildren()}
                </div>
              </div>
  
              <FormControls formik={formik} submitActionRef={submitActionRef}/>
            </div>
          </FormikForm>
        )
      }}
    </Formik>
  );
}

export default Form;